<template>
    <div>
        <video ref="videoPlayer" class="video-js vjs-big-play-centered vjs-16-9"></video>
    </div>
</template>

<script>
import videoJs from 'video.js'
import 'video.js/dist/video-js.css'
require('videojs-contrib-quality-levels')
require('videojs-hls-quality-selector')

export default {
  name: 'video-player',
  props: ['sources'],
  data () {
    return {
      player: null,
      options: {
        controls: true,
        autoplay: false,
        sources: this.sources,
        responsive: true,
        html5: {
          hls: {
            overrideNative: true
          }
        }
      }
    }
  },
  mounted () {
    this.player = videoJs(this.$refs.videoPlayer, this.options)
    this.player.hlsQualitySelector({ displayCurrentQuality: true })
    const levels = this.player.qualityLevels()
    levels.trigger({ type: 'change', selectedIndex: 2 })
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
